import { ParentGetRequest, ParentGetResponse } from '../../../types/users'
import { useApiPostQuery } from '../useApi'

export const useParentGet = (
  requestData: { ID: number },
  enabled: boolean = true
) => {
  return useApiPostQuery<ParentGetResponse>(
    '/users/get-parent',
    ['parentDetail', requestData.ID],
    requestData,
    enabled
  )
}
